import { TabGroup } from '@fiverr-private/navigation';

export default TabGroup;
